import { AvailabilityView } from "@tellescope/calendar";
import { CalendarPageTabsHeader } from "./CalendarPageTabsHeader";
import { useShallowCalendarStore } from "../../store";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

export const CalendarAvailabilityPage = () => {
  const { t } = useTranslation("calendar");
  const { selectedUserIds } = useShallowCalendarStore("selectedUserIds");

  return (
    <div className="flex flex-col h-full min-h-0 overflow-hidden">
      <CalendarPageTabsHeader />
      <AvailabilityView
        userIds={selectedUserIds}
        onCopySuccess={({ length }) => toast.success(t("Availability copied to {{count}} users", { count: length }))}
        onCopyError={({ length }) => toast.error(t("Error copying availability to {{count}} users", { count: length }))}
      />
    </div>
  );
};
